import { ShieldCheck } from "lucide-react";

export const VerifiedBadge = ({ date }) => (
  <span
    data-testid="verified-badge"
    className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold border border-emerald-200"
  >
    <ShieldCheck className="w-3.5 h-3.5" />
    Verified{date ? ` · ${new Date(date).toLocaleDateString()}` : ""}
  </span>
);
